import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e0a53770 = () => interopDefault(import('../pages/diem-chuan/index.vue' /* webpackChunkName: "pages/diem-chuan/index" */))
const _69d449e0 = () => interopDefault(import('../pages/diem-thi/index.vue' /* webpackChunkName: "pages/diem-thi/index" */))
const _f4726b18 = () => interopDefault(import('../pages/livestream.vue' /* webpackChunkName: "pages/livestream" */))
const _13b21faa = () => interopDefault(import('../pages/master-test-3.vue' /* webpackChunkName: "pages/master-test-3" */))
const _271aa471 = () => interopDefault(import('../pages/sukien.vue' /* webpackChunkName: "pages/sukien" */))
const _bb01fecc = () => interopDefault(import('../pages/test.vue' /* webpackChunkName: "pages/test" */))
const _5211395a = () => interopDefault(import('../pages/user.vue' /* webpackChunkName: "pages/user" */))
const _5da9a315 = () => interopDefault(import('../pages/viewer-test.vue' /* webpackChunkName: "pages/viewer-test" */))
const _7392640c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0274906d = () => interopDefault(import('../pages/event/_id.vue' /* webpackChunkName: "pages/event/_id" */))
const _a4f0abb2 = () => interopDefault(import('../pages/school/_id.vue' /* webpackChunkName: "pages/school/_id" */))
const _59241c7e = () => interopDefault(import('../pages/_type.vue' /* webpackChunkName: "pages/_type" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/eduzone/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/diem-chuan",
    component: _e0a53770,
    name: "diem-chuan"
  }, {
    path: "/diem-thi",
    component: _69d449e0,
    name: "diem-thi"
  }, {
    path: "/livestream",
    component: _f4726b18,
    name: "livestream"
  }, {
    path: "/master-test-3",
    component: _13b21faa,
    name: "master-test-3"
  }, {
    path: "/sukien",
    component: _271aa471,
    name: "sukien"
  }, {
    path: "/test",
    component: _bb01fecc,
    name: "test"
  }, {
    path: "/user",
    component: _5211395a,
    name: "user"
  }, {
    path: "/viewer-test",
    component: _5da9a315,
    name: "viewer-test"
  }, {
    path: "/",
    component: _7392640c,
    name: "index"
  }, {
    path: "/event/:id?",
    component: _0274906d,
    name: "event-id"
  }, {
    path: "/school/:id?",
    component: _a4f0abb2,
    name: "school-id"
  }, {
    path: "/:type",
    component: _59241c7e,
    name: "type"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
